import React from 'react';
import Lottie from 'react-lottie-player';
import lottieJson from './animation.json';

const Loader = ({}) => {
  return <Lottie loop animationData={lottieJson} play style={{ width: 100, height: 100 }} />;
};

export default Loader;
